// src/components/Reviews/Reviews.js

import React, { useEffect, useState } from "react";
import "./Review.css";

import { db } from "../../firebase";

import {
  collection,
  addDoc,
  getDocs,
  query,
  orderBy,
  serverTimestamp
} from "firebase/firestore";

import { FaStar } from "react-icons/fa";

function Reviews() {
  const [reviews, setReviews] = useState([]);

  const [formData, setFormData] = useState({
    name: "",
    rating: 0,
    review: ""
  });

  const [loading, setLoading] = useState(false);

  /* FETCH REVIEWS */
  const fetchReviews = async () => {
    try {
      const q = query(
        collection(db, "reviews"),
        orderBy("createdAt", "desc")
      );

      const snapshot = await getDocs(q);

      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data()
      }));

      setReviews(data);

    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchReviews();
  }, []);

  /* INPUT CHANGE */
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  /* STAR CLICK */
  const handleStarClick = (value) => {
    setFormData({
      ...formData,
      rating: value
    });
  };

  /* SUBMIT */
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.rating === 0) {
      alert("Please select rating");
      return;
    }

    try {
      setLoading(true);

      await addDoc(collection(db, "reviews"), {
        name: formData.name,
        rating: formData.rating,
        review: formData.review,
        createdAt: serverTimestamp()
      });

      setFormData({
        name: "",
        rating: 0,
        review: ""
      });

      fetchReviews();

    } catch (error) {
      console.log(error);
    }

    setLoading(false);
  };

  return (
    <section className="review-section">

      <div className="review-container">

        <p className="review-tag">
          PATIENT REVIEWS
        </p>

        <h2>
          Share Your Experience
        </h2>
 <div className="review-grid">

          {reviews.map((item) => (
            <div
              className="review-card"
              key={item.id}
            >

              <h3>{item.name}</h3>

              <div className="review-stars">
                {[1,2,3,4,5].map((star) => (
                  <FaStar
                    key={star}
                    className={
                      star <= item.rating
                        ? "filled"
                        : ""
                    }
                  />
                ))}
              </div>

              <p>{item.review}</p>

            </div>
          ))}

        </div>
        {/* FORM */}
        <form
          className="review-form"
          onSubmit={handleSubmit}
        >

          <input
            type="text"
            placeholder="Your Name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />

          <div className="star-box">
            {[1,2,3,4,5].map((star) => (
              <FaStar
                key={star}
                className={
                  star <= formData.rating
                    ? "star active-star"
                    : "star"
                }
                onClick={() => handleStarClick(star)}
              />
            ))}
          </div>

          <textarea
            rows="5"
            placeholder="Write your review"
            name="review"
            value={formData.review}
            onChange={handleChange}
            required
          ></textarea>

          <button type="submit">
            {loading ? "Submitting..." : "Submit Review"}
          </button>

        </form>

       
       

      </div>

    </section>
  );
}

export default Reviews;